/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./register.module.sass";
import { Search } from "components-new";
import { Button } from "components/shared";
import ModalPortal from "components-new/ModalPortal";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import useDebounce from "hooks/useDebounce";
import InputTemp from "components-new/InputTemp";
import { useValidate } from "hooks/useValidate";
import { AxiosError } from "axios";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import TextArea from "components-new/Textarea";
import { useLocation, useNavigate } from "react-router-dom";
import { snackWrapper } from "helpers";
import { usePaginationWithIntersection } from "../../../hooks/usePaginationWithIntersection";
import Badge from "components-new/Badge";
import { useAppDispatch } from "toolkit/hooks";
import { checkCompletingReferences } from "toolkit/references/references.thunks";
import {directoryAPI} from "libs/apiClient/Directory";
import {userAPI} from "libs/apiClient/User";

const initial: Omit<ITypeKapStroy, "responsible"> & { responsible?: { fullName: string; id: number } } = {
	address: "",
	inventoryNumber: "",
	department: "",
	name: "",
	electricConnectionCategory: "",
	electricConnectionMedium: "",
	electricConnectionProvider: "",
	electricConnectionPurpose: "",
};
const Modal: React.FC<{
	rootFunc: Dispatch<SetStateAction<ITypeKapStroy[]>> | Dispatch<SetStateAction<ITypeKapStroy[] | null>>;
	trigger: {
		active: boolean;
		data: (Omit<ITypeKapStroy, "responsible"> & { responsible?: { fullName: string; id: number } }) | null;
	};
	cancelWindow: () => void;
}> = ({ trigger, rootFunc, cancelWindow }) => {
	const [newType, setNewType] = useState<
		Omit<ITypeKapStroy, "responsible"> & { responsible?: { fullName: string; id: number } }
	>(initial);
	const dispatch = useAppDispatch();
	useEffect(() => {
		if (trigger.data) {
			setNewType(trigger.data);
			setSearchEmployee(trigger.data.responsible?.fullName || "");
		} else {
			setNewType(initial);
		}
	}, [trigger.data]);
	const [errors, setErrors] = useState<string[]>([]);

	const send = () => {
		if (!trigger.data) {
			const { responsible, department, ...rest } = newType;
			directoryAPI.constructionObjectCreate( { ...rest, responsible: responsible?.id! })
				.then((r) => {
					snackWrapper("success", "Запись успешно создана");
					rootFunc((prevState: any) => [...prevState, r.data]);
					cancelWindow();
					dispatch(checkCompletingReferences());
				})
				.catch((e: AxiosError) => {
					if (e.response && e.response.status === 409 && e.response.data) {
						setErrors(e.response.data as []);
						setTimeout(() => {
							setErrors([]);
						}, 3000);
					}
				});
		} else {
			const { id, responsible, department, ...rest } = newType;
			directoryAPI.constructionObjectUpdate(id!, { ...rest, responsible: responsible?.id! })
				.then((r) => {
					snackWrapper("success", "Запись успешно отредактирована");
					rootFunc((prevState: any) => [...prevState].map((_) => (_.id === r.data.id ? { ...r.data } : _)));
					cancelWindow();
					dispatch(checkCompletingReferences());
				})
				.catch((e: AxiosError) => {
					if (e.response && e.response.status === 409 && e.response.data) {
						setErrors(e.response.data as []);
						setTimeout(() => {
							setErrors([]);
						}, 3000);
					}
				});
		}
	};

	const { error, validate } = useValidate(
		newType,
		[
			"name",
			"address",
			"inventoryNumber",
			"responsible",
			"electricConnectionCategory",
			"electricConnectionMedium",
			"electricConnectionProvider",
			"electricConnectionPurpose",
		],
		send,
	);

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let { name, value } = e.target;
		if (/^\s/.test(value)) value = value.replace(/^\s/, "");
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};
	useEffect(() => {
		return () => setErrors([]);
	}, [trigger.active]);

	// const [employees, setEmployees] = useState<
	// 	{
	// 		fullName: string;
	// 		id: number;
	// 		position: {
	// 			id: number;
	// 			name: string;
	// 		};
	// 	}[]
	// >([]);

	const [searchEmployee, setSearchEmployee] = useState("");
	// const debounce = useDebounce(searchEmployee, 400);
	// useEffect(() => {
	// 	if (debounce) {
	// 		$api
	// 			.get("/employees/short", {
	// 				params: {
	// 					page: 1,
	// 					num: 10,
	// 					query: debounce,
	// 				},
	// 			})
	// 			.then(({ data }) => {
	// 				setEmployees(data);
	// 			});
	// 	} else {
	// 		setEmployees([]);
	// 	}
	// }, [debounce]);

	useEffect(() => {
		return () => {
			setNewType(initial);
			setSearchEmployee("");
		};
	}, [trigger]);

	return trigger.active ? (
		<ModalPortal
			outSide={false}
			size={"sm"}
			title={trigger.data ? "Редактировать объект" : "Создать объект"}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<InputTemp
					name={"inventoryNumber"}
					value={newType.inventoryNumber}
					onChange={changeField}
					errorText={errors.length && errors.includes("inventory_number") ? "Такой номер уже есть" : ""}
					error={error && !newType.inventoryNumber}
					placeholder={"Введите текст"}
					label={"Инвентарный номер"}
					required
				/>
				<TextArea
					rows={3}
					name={"name"}
					onChange={changeField}
					error={error && !newType.name}
					value={newType.name}
					maxLength={150}
					placeholder={"Введите текст"}
					label={"Наименование"}
					required
				/>
				<TextArea
					rows={2}
					name={"address"}
					onChange={changeField}
					error={error && !newType.address}
					value={newType.address}
					maxLength={150}
					placeholder={"Введите текст"}
					label={"Адрес"}
					required
				/>
				<InputTemp
					onChange={(e) => setSearchEmployee(e.target.value)}
					value={searchEmployee || ""}
					onBlur={() => {
						if (newType.responsible?.fullName) {
							setSearchEmployee(newType.responsible?.fullName || "");
						}
					}}
					emptyOptions={false}
					error={(error && !newType.responsible) || (newType.responsible && !newType.responsible.fullName)}
					field={["fullName"]}
					remote={{
						link: "/employees/short",
						initialParams: {
							page: 1,
							num: 20,
						},
					}}
					onSelect={(item) => {
						setNewType((prevState) => ({ ...prevState, responsible: item, department: item.department }));
						setSearchEmployee(item.fullName);
					}}
					placeholder={"Введите текст"}
					label={"Ответственный"}
					required
				/>

				<InputTemp
					onChange={changeField}
					value={newType.electricConnectionCategory}
					name={"electricConnectionCategory"}
					error={error && !newType.electricConnectionCategory}
					placeholder={"Введите текст"}
					label={"Категория сети электросвязи"}
					required
				/>
				<TextArea
					rows={2}
					name={"electricConnectionProvider"}
					onChange={changeField}
					error={error && !newType.electricConnectionProvider}
					value={newType.electricConnectionProvider}
					maxLength={150}
					placeholder={"Введите текст"}
					label={"Оператор связи"}
					required
				/>
				<InputTemp
					onChange={changeField}
					value={newType.electricConnectionPurpose}
					name={"electricConnectionPurpose"}
					error={error && !newType.electricConnectionPurpose}
					placeholder={"Введите текст"}
					label={"Цель взаимодействия с электросвязью"}
					required
				/>
				<InputTemp
					onChange={changeField}
					name={"electricConnectionMedium"}
					value={newType.electricConnectionMedium}
					error={error && !newType.electricConnectionMedium}
					placeholder={"Введите текст"}
					label={"Способ взаимодействия с электросвязью"}
					required
				/>

				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button onClick={validate}>Готово</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

interface ITypeKapStroy {
	address: string;
	department: string;
	electricConnectionCategory: string;
	electricConnectionMedium: string;
	electricConnectionProvider: string;
	electricConnectionPurpose: string;
	id?: number;
	inventoryNumber: string;
	name: string;
	responsible?: {
		firstName: string;
		id?: number;
		lastName: string;
		middleName: string;
		position?: {
			id: number;
			name: string;
		};
	};
}

const RegisterOfKapstroy = () => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const [data, setData] = useState<ITypeKapStroy[]>([]);
	// const [filter, setFilter] = useState<ITypeKapStroy[] | null>(null);
	const [search, setSearch] = useState("");

	const query = useDebounce(search, 400);

	const firstLoad = useRef(true);

	const [params, setParams] = useState({
		page: 1,
		num: 30,
		query: query,
		archive: false,
	});
	const isArchive = useMemo(() => {
		console.log("navigate");
		return /.+\/archive$/.test(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		setParams((prevState) => ({ ...prevState, page: 1, query, archive: isArchive }));
		setFetch(true);
		setIsFinally(false);
		//eslint-disable-next-line
	}, [query, isArchive]);

	// useEffect(() => {
	// 	$api
	// 		.get("/directory/construction-object/list", {
	// 			params: {
	// 				page: 1,
	// 				num: 99999999,
	// 			},
	// 		})
	// 		.then((r) => setData(r.data));
	// }, []);

	const [modal, setModal] = useState<{
		active: boolean;
		data: (Omit<ITypeKapStroy, "responsible"> & { responsible?: { fullName: string; id: number } }) | null;
	}>({
		active: false,
		data: null,
	});

	// useEffect(() => {
	// 	if (query as string) {
	// 		$api
	// 			.get("/directory/construction-object/list", {
	// 				params: {
	// 					query,
	// 					page: 1,
	// 					num: 99999999,
	// 				},
	// 			})
	// 			.then((r) => setFilter(r.data));
	// 	} else if (query === "") {
	// 		setFilter(null);
	// 	}
	// }, [query]);

	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();

	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};
	const removeItem = () => {
		const id = target?.dataset.id;
		/* путь для физического удаления записи в БД */
		// $api.post(`/directory/activity-areas/${id}/delete`).then(() => {

		/* путь для отправки записи "в архив" в БД */
		directoryAPI.constructionObjectArchiveDetail(+id!)
			.then(() => {
				setData((prevState) => [...prevState].filter((_) => _.id !== Number(id)));
				snackWrapper("success", "Запись перемещена в архив");
				setTarget(undefined);
				dispatch(checkCompletingReferences());
			})
			.catch((error) => {
				if (error.response.status === 500) {
					// snackWrapper('success','Запись удалена')
				}
				setTarget(undefined);
			});
	};
	const menuRef = useRef<any>(null);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (menuRef.current && target && !menuRef.current.contains(event.target)) {
				setTarget(undefined);
			}
		}

		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [target]);
	const [disabled, setDisabled] = useState(false);
	const needRule = useCallback(() => {
		if (disabled) snackWrapper("error", "Не достаточно прав");
	}, [disabled]);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["dictionary.construction_objects.edit"])
			.then((r) => setDisabled(!r.data.length));
	}, []);

	const thenHandler = useCallback(
		(data: ITypeKapStroy[]) => {
			const upPage = (prevState: typeof params) => ({ ...prevState, page: prevState.page + 1 });
			if (params.page === 1) {
				if (data.length) {
					if (data.length < params.num) {
						setIsFinally(true);
					} else {
						setParams(upPage);
					}
				} else {
					setIsFinally(true);
				}
				setData(data);
			} else {
				if (data.length) {
					if (data.length < params.num) {
						setIsFinally(true);
					} else {
						setParams(upPage);
					}
					setData((prevState) => [...prevState, ...data]);
				} else {
					setIsFinally(true);
				}
			}
			//eslint-disable-next-line
		},[params],
	);

	const goToArchive = () => {
		navigate(location.pathname + "/archive", { state: location.state });
	};

	const wrapperRef = useRef<HTMLDivElement | null>(null);
	const lastRef = useRef<HTMLTableRowElement | null>(null);

	const { setIsFinally, setFetch } = usePaginationWithIntersection<ITypeKapStroy>({
		link: "/directory/construction-object/list",
		params,
		dependencies: [!firstLoad.current, params],
		ref: wrapperRef,
		then: thenHandler,
		lastTarget: lastRef,
	});

	useEffect(() => {
		if (firstLoad.current) firstLoad.current = false;
	}, []);

	const restoreItem = () => {
		const id = target?.dataset.id;

		directoryAPI.constructionObjectArchiveDelete(+id!)
			.then(() => {
				setData((prevState) => [...prevState].filter((_) => _.id !== Number(id)));
				snackWrapper("success", "Запись восстановлена");
				setTarget(undefined);
			})
			.catch((error) => {
				if (error.response.status === 500) {
					// snackWrapper('success','Запись удалена')
				}
				setTarget(undefined);
			});
	};
	return (
		<div className={sass.wrapper}>
			<Modal
				rootFunc={setData}
				trigger={modal}
				cancelWindow={() => setModal((prevState) => ({ ...prevState, active: false }))}
			/>
			<DropMenu ref={menuRef} target={target} clear={true} click={() => {}}>
				{!isArchive ? (
					<div className={sass.remove} onClick={removeItem}>
						<div className={sass.icon} />В архив
					</div>
				) : (
					<div className={sass.restore} onClick={restoreItem}>
						<div className={sass.icon} />
						Восстановить
					</div>
				)}
			</DropMenu>
			<HeadPage
				title={
					<div className={sass.title_head}>
						Объекты капитального строительства {isArchive && <Badge color={"#7CADAA"}>Архив</Badge>}
					</div>
				}>
				<div className={sass.head}>
					<Search className={sass.search} searchValue={search} handleSearch={(e) => setSearch(e.target.value)} />

					{!isArchive && (
						<>
							<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={goToArchive}>
								Архив
							</Button>
							<Button disabled={disabled} onClick={() => setModal({ active: true, data: null })}>
								Добавить значение
							</Button>
						</>
					)}
				</div>
			</HeadPage>
			<table>
				<thead>
					<tr>
						<th>Инвентарный номер</th>
						<th>Наименование</th>
						<th>Адрес</th>
						<th>Ответственный</th>
						<th>Подразделение</th>
						<th>Категория сети электросвязи</th>
						<th>Оператор связи</th>
						<th>Цель взаимодействия с электросвязью</th>
						<th>Способ взаимодействия с электросвязью</th>
						<th />
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll} ref={wrapperRef}>
				<table>
					<tbody>
						{
							// filter
							// ? filter.map((_, index) => (
							// 		<tr
							// 			className={
							// 				location.state && location.state?.outline && location.state?.outline === _.id ? sass.outline : ""
							// 			}
							// 			onClick={() =>
							// 				disabled
							// 					? needRule()
							// 					: setModal({
							// 							active: true,
							// 							data: {
							// 								..._,
							// 								responsible: {
							// 									id: _.responsible?.id || 0,
							// 									fullName: `${_.responsible?.lastName} ${_.responsible?.firstName} ${_.responsible?.middleName}`,
							// 								},
							// 							},
							// 					  })
							// 			}
							// 			key={index}>
							// 			<td>{_.inventoryNumber}</td>
							// 			<td>{_.name}</td>
							// 			<td>{_.address}</td>
							// 			<td
							// 				onClick={(e) => {
							// 					e.preventDefault();
							// 					navigate("/employee/" + _.responsible?.id);
							// 				}}
							// 				className={sass.link}>
							// 				{_.responsible?.lastName} {_.responsible?.firstName} {_.responsible?.middleName}
							// 			</td>
							// 			<td>{_.department}</td>
							// 			<td>{_.electricConnectionCategory}</td>
							// 			<td>{_.electricConnectionProvider}</td>
							// 			<td>{_.electricConnectionPurpose}</td>
							// 			<td>{_.electricConnectionMedium}</td>
							// 			<td>
							// 				<ActionMenuIcon data-id={_.id} onClick={toggleTarget} />
							// 			</td>
							// 		</tr>
							//   ))
							// :
							data.map((_, index) => (
								<tr
									className={
										location.state && location.state?.outline && location.state?.outline === _.id ? sass.outline : ""
									}
									onClick={() => {
										disabled
											? needRule()
											: setModal({
													active: true,
													data: {
														..._,
														responsible: {
															id: _.responsible?.id || 0,
															fullName: `${_.responsible?.lastName} ${_.responsible?.firstName} ${_.responsible?.middleName}`,
														},
													},
											  });
									}}
									key={index}>
									<td>{_.inventoryNumber}</td>
									<td>{_.name}</td>
									<td>{_.address}</td>
									<td
										onClick={(e) => {
											e.preventDefault();
											navigate("/employee/" + _.responsible?.id);
										}}
										className={sass.link}>
										{_.responsible?.lastName} {_.responsible?.firstName} {_.responsible?.middleName}
									</td>
									<td>{_.department}</td>
									<td>{_.electricConnectionCategory || <span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />}</td>
									<td>{_.electricConnectionProvider || <span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />}</td>
									<td>{_.electricConnectionPurpose || <span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />}</td>
									<td>{_.electricConnectionMedium || <span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />}</td>
									<td>
										<ActionMenuIcon data-id={_.id} onClick={toggleTarget} />
									</td>
								</tr>
							))
						}
						<tr ref={lastRef} />
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default RegisterOfKapstroy;
